export default __webpack_public_path__ + "static/media/datepicker-arrow-left.9c1d5eac.svg";